import React from "react";
import CricketPage from "./exchange/member/CricketPage";
import { useGetTennisMatchesQuery } from "../../store/services/mainApi";
import Loader from "../components/Loader";
import Error from "../components/Error";

export default function PrivateTennisScreen() {
  // const { data, isFetching, error } = useGetTennisMatchesQuery();
  // if (isFetching) {
  //   return <Loader />;
  // }
  // if (error) {
  //   return <Error />;
  // }
  return (
    <>
      <CricketPage
      // activeName="Tennis"
      // activeApi={[{ title: "Tennis", active: true }]}
      // tennisMatch={data}
      />
      ;
    </>
  );
}
